import '../../../../stylesheets/components/device_info_window.scss';

class DeviceInfoWindow {
  constructor(key, domElement) {
    this.domElement = domElement;
    this.key = key;
    this.anchor = null;
  }

  open(anchor) {
    if (this.anchor) {
      this.anchor.removeDrawListener(this.key);
    }

    this.anchor = anchor;
    this.anchor.addDrawListener(this.key, this.onAnchorDraw);

    this.onAnchorDraw();
  }

  onAnchorDraw = () => {
    const position = this.anchor.getPositionInContainer();

    this.domElement.classList.add('device-info-window--visible');
    this.domElement.style.top = `${position.y - this.domElement.offsetHeight - 20}px`;
    this.domElement.style.left = `${position.x + 30}px`;
  }

  close() {
    if (this.anchor) {
      this.domElement.classList.remove('device-info-window--visible');
      this.anchor.removeDrawListener(this.key);
      this.anchor = null;
    }
  }
}

export default DeviceInfoWindow;
